<template>
  <div class="header">
    <div class="justify-between">
      <div class="flex-row">
        <img src="@/assets/imgs/logo.svg" class="image" @click="goHome" />
      </div>
      <van-icon name="wap-nav" class="menu" @click="changeNavIcon" />
    </div>
    <van-popup position="top" v-model="navIcon" class="popup">
      <!-- <div class="justify-between"> -->
      <div
        class="flex-row"
        style="
          justify-content: space-between;
          width: 90%;
          margin: 0.1333rem auto;
        "
      >
        <img src="@/assets/imgs/logo.svg" class="image" />
        <van-icon name="cross" class="menu" @click="changeNavIcon" />
      </div>

      <!-- <van-field class="search-box" placeholder="请输入关键词搜索"></van-field> -->
      <van-search
        v-model="value"
        shape="round"
        placeholder="请输入搜索关键词"
          show-action
          :clearable="false"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div v-for="(navListItem, index) in navList" :key="index">
        <div
          @click="goLink(navListItem)"
          class="firstNav"
          v-if="navListItem.subNav.length == 0"
          v-show="!menuHidden.includes(navListItem.title)"
        >
          {{ navListItem.title }}
        </div>
        <div v-else class="firstNav-box">
          <van-collapse v-model="activeNames">
            <van-collapse-item
              :title="navListItem.title"
              :name="index"
              class="secondNav-box"
            >
              <van-collapse
                class="secondNav0"
                v-model="activeName"
                v-for="(item, index1) in navListItem.subNav"
                :key="index1"
              >
                <div
                  @click="goLink(item)"
                  class="secondNav"
                  v-if="item.subNav.length == 0"
                >
                  {{ item.title }}
                </div>
                <div v-else>
                  <van-collapse-item :title="item.title" :name="index1">
                    <div
                      @click="goLink(subNavItem)"
                      class="thirdNav"
                      v-for="(subNavItem, index2) in item.subNav"
                      :key="index2"
                    >
                      {{ subNavItem.title }}
                    </div>
                  </van-collapse-item>
                </div>
              </van-collapse>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
      <!-- <van-button type="info">登录</van-button> -->
    </van-popup>
  </div>
</template>

<script>
import { getNav } from "@/api/nav.js";
import { menuHidden } from 'defaultconfig'
export default {
  data() {
    return {
      value: "",
      navIcon: false,
      navList: [],
      activeName: [],
      activeNames: [],
      menuHidden
    };
  },
  mounted() {
    this.getNavList();
  },
  methods: {
    changeNavIcon() {
      this.navIcon = !this.navIcon;
    },
    getNavList() {
      getNav({ navType: "nav" }).then((res) => {
        this.navList = res.data;
      });
    },
    goHome() {
      // this.goRoute('/home')
      this.$router.push({
        path: "/home",
      });
    },
    goLink(val) {
      this.navIcon = false;
      (this.activeName = []), (this.activeNames = []);
      document.location = val.link
      // if (val.link.indexOf("store") > -1) {
      //   this.goRoute("/store");
      // } else if (val.link.indexOf("develop") > -1) {
      //   this.goRoute("/develop");
      // } else {
      //   this.interceptUrl(val.link, "/").then((res) => {
      //     let path = "";
      //     let key = "";
      //     let value = "";
      //     if (res.indexOf("?") > -1) {
      //       path = res.split("?")[0];
      //       this.interceptUrl(res, "?").then((result) => {
      //         if (result.indexOf("&") > -1) {
      //           const query = result.split("&");
      //           let queryObj = {};
      //           if (query.length == 2) {
      //             query.forEach((item) => {
      //               queryObj[item.split("=")[0]] = item.split("=")[1];
      //             });
      //           }
      //           this.goRoute("/" + path, "", "", queryObj);
      //         } else {
      //           key = result.split("=")[0];
      //           value = result.split("=")[1];
      //           this.goRoute("/" + path, key, value);
      //         }
      //       });
      //     } else {
      //       this.goRoute("/" + res);
      //     }
      //   });
      // }
    },
    goRoute(path, key, value, queryObj) {
      if (queryObj) {
        this.$router.push({
          path: path,
          query: queryObj,
        });
      } else {
        this.$router.push({
          path: path,
          query: {
            [key]: value,
          },
        });
      }
    },
    onSearch(){
      this.navIcon=false
      this.$router.push({ path: 'search', query: { val: this.value, t:Date.now() } })
      this.value=''
    },
    async interceptUrl(url, cha) {
      var ind = url.lastIndexOf(cha);
      return url.substring(ind + 1);
    },
  },
  watch: {
    $route: {
      handler: function () {
        this.navIcon = false;
      (this.activeName = []), (this.activeNames = []);
      },
      // 深度观察监听
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.search-box::after {
  border: none;
}
/deep/.van-search {
  .van-search__content {
    background-color: #fff;
  }
  .van-field {
    margin: 0 auto !important;
    padding-left: 0.2667rem;
    border: solid 0.0266rem #e8e8e8 !important;
  }
}
/deep/.van-popup {
  padding-bottom: 2rem;
}
.firstNav {
  padding: 0.26667rem 0.42667rem;
  color: #323233;
  font-size: 0.37333rem;
  line-height: 0.64rem;
  border-bottom: 0.0266rem solid #ebedf0;
}
.secondNav {
  padding: 0.26667rem 0.42667rem;
  color: #666666;
  font-size: 0.37333rem;
  line-height: 0.64rem;
  padding-left: 0.8rem;
  border-bottom: 0.0266rem solid #ebedf0;
}
/deep/.secondNav0 {
  .van-cell__title {
    color: #666;
    padding-left: 0.32rem;
  }
}
/deep/.firstNav-box {
  .van-collapse.van-hairline--top-bottom::after {
    border: none;
  }
}
/deep/.secondNav-box {
  .van-cell {
    border-bottom: 0.0266rem solid #ebedf0;
  }
  .van-collapse-item__content {
    padding: 0;
  }
  /deep/.van-cell::after {
    border: none;
  }
  .van-collapse.van-hairline--top-bottom::after {
    border: none;
  }
}
.thirdNav {
  color: #898989;
  font-size: 0.37333rem;
  line-height: 0.64rem;
  padding: 0.26667rem 0.42667rem;
  padding-left: 80px;
  border-bottom: solid 0.0266rem #ebedf0;
}
.van-popup {
  transition: none;
}
.header {
  padding: 0.23rem 0.4rem 0.16rem;
  .image {
    width: 6.7067rem;
    height: 0.9333rem;
  }
  .menu {
    align-self: center;
    color: #333333;
    font-size: 0.56rem;
    font-weight: 500;
    line-height: 0.4rem;
  }
  .jdc-nav-btn {
    display: inline-block;
    padding: 0.1067rem;
    vertical-align: middle;
    margin-top: 0.2667rem;
    span {
      display: block;
      width: 0.4267rem;
      height: 0.0533rem;
      position: relative;
      background: #212121;
      border-radius: 0.04rem;
      z-index: 1;
      transform-origin: 0.2667rem;
      transition: background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
        opacity 0.55s ease, transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
        width 0.5s;
      transition-property: background, opacity, transform, width;
      transition-duration: 0.5s, 0.55s, 0.5s, 0.5s;
      transition-timing-function: cubic-bezier(0.77, 0.2, 0.05, 1), ease,
        cubic-bezier(0.77, 0.2, 0.05, 1), ease;
      transition-delay: 0s, 0s, 0s, 0s;
    }
  }
  .jdc-nav-btn-actived {
    span {
      opacity: 1;
      -ms-transform: rotate(40deg);
      transform: rotate(40deg);
    }
    span:nth-last-child(3) {
      opacity: 1;
      -ms-transform: rotate(-43deg);
      transform: rotate(-43deg);
    }
    span:nth-last-child(2) {
      width: 0;
      opacity: 0;
      -ms-transform: rotate(0);
      transform: rotate(0);
      transition: width 0.5s;
      height: 0;
      margin-top: 0 !important;
    }
  }
  .van-cell.van-field {
    border: solid 1px #e8e8e8;
    width: 90%;
    margin: 0.5333rem auto;
    border-radius: 0.8rem;
  }
}

/deep/.van-collapse-item__title--expanded .van-cell__right-icon::before {
  color: #2962cb;
}
/deep/.van-collapse-item__title--expanded {
  color: #2962cb;
  .van-cell__title {
    color: #2962cb;
  }
}

/deep/.van-collapse-item__title--expanded::after {
  border-bottom: none;
}
.popup {
  /deep/.van-button--normal {
    padding: 0 0.4rem;
    font-size: 0.37333rem;
    width: 70%;
    margin: 0.26667rem 15%;
  }
  /deep/.van-button--info {
    color: #fff;
    background-color: #2962cb;
    border: 0.02667rem solid #2962cb;
  }
  /deep/ .van-field__left-icon {
    position: absolute;
    right: 0.3333rem;
  }
  /deep/ .van-search__action {
    position: absolute;
    right: 0.6rem;
    opacity: 0;
  }
  /deep/ .van-search__content {
    padding-right: 0.5333rem;
  }
  /deep/ .van-field__control{
    width: 90%;
  }
}
</style>
